/* eslint-disable */
export default {
  data() {
    return {
      tooltipPlacement: window.innerWidth < 960 ? 'bottom' : 'right',
    };
  },
  methods: {
    getTooltip(titre, contenu) {
      const t = this.$t(titre);
      const c = this.$t(contenu);
      return `<div  class='text-left' style='background-color:#f7f7f7;'>
                <h3 class="popover-title" style="line-height: 28px">${t}</h3>
              </div>
              <div class="popover-content text-left" style='padding: 10px 10px 10px;font-size: 16px;'>
                ${c}
              </div>`;
    },
    getTooltipAvecOptions(titre, contenu, optionsTitre, optionsContenu) {
      const t = this.$t(titre, optionsTitre);
      const c = this.$t(contenu, optionsContenu);
      return `<div  class='text-left' style='background-color:#f7f7f7;'>
                <h3 class="popover-title" style="line-height: 28px">${t}</h3>
              </div>
              <div class="popover-content text-left" style='padding: 10px 10px 10px;font-size: 16px;'>
                ${c}
              </div>`;
    },
    onResize(event) {
      this.tooltipPlacement = window.innerWidth < 960 ? 'bottom' : 'right';
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
